
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DateTimeValueFormatUnixTimestampSeconds, VfbElement, VfbElementType } from './Element';

@Component
export default class ElementDateExtra extends Vue {
  @Prop({ required: true })
  builderElement!: VfbElement;

  private alarmTagIdentifier = 'ALARM';

  get alarmTag(): boolean {
    let el = this.builderElement.tags;
    return Array.isArray(el) && el.includes(this.alarmTagIdentifier);
  }

  set alarmTag(value: boolean) {
    let el = this.builderElement.tags;

    if (typeof el === 'undefined' || !Array.isArray(el)) {
      this.$set(this.builderElement, 'tags', value ? [this.alarmTagIdentifier] : []);
      return;
    }
    const index = el.indexOf(this.alarmTagIdentifier);

    if (value && index === -1) {
      el.push(this.alarmTagIdentifier);
    } else if (!value && index !== -1) {
      el.splice(index, 1);
    }
  }

  get valueFormat(): boolean {
    return this.builderElement.valueFormat === DateTimeValueFormatUnixTimestampSeconds;
  }

  set valueFormat(value: boolean) {
    if (typeof this.builderElement.valueFormat === 'undefined') {
      this.$set(this.builderElement, 'valueFormat', DateTimeValueFormatUnixTimestampSeconds); // if property didn't exist, it needs to be set this way, so vue makes it reactive
    }
    if (value) {
      this.builderElement.valueFormat = DateTimeValueFormatUnixTimestampSeconds;
    } else {
      this.$delete(this.builderElement, 'valueFormat');
    }
  }

  get uid(): string {
    return this._uid;
  }
}
